import { getATLContextUrl, getUrlForDomainInContext, isIsolatedCloud } from '@atlaskit/atlassian-context';

export const redirectToHome = ({
	email,
	orgId,
	cloudId,
}: {
	email: string;
	orgId?: string;
	cloudId: string;
}): void => {
	const urlWithSynchronisation = getSessionSynchronisationUrl(
		buildAtlassianHomeUrl({ orgId, cloudId }),
		email,
	);

	window.location.assign(urlWithSynchronisation);
};

export function buildAtlassianHomeUrl({ orgId, cloudId }: { orgId?: string; cloudId: string }) {
	let homeRedirectUrl: string;
	if (isIsolatedCloud()) {
		homeRedirectUrl = (getUrlForDomainInContext('home', 'prod') ?? getATLContextUrl('home')).replace(
			'http:',
			'https:',
		);
	} else {
		homeRedirectUrl = getATLContextUrl('home').replace('http:', 'https:');
	}

	const searchParams = new URLSearchParams(window.location.search);
	searchParams.set('cloudId', cloudId);
	return `${homeRedirectUrl}${
		orgId ? `/o/${orgId}` : ''
	}${getRedirectPath()}?${searchParams.toString()}`;
}

function getRedirectPath() {
	const fullPath = window.location.pathname;
	// Remove everything before /people
	return fullPath.substring(fullPath.indexOf('/people'));
}

function getLogInUrl(redirectUrl?: string) {
	const href = redirectUrl || window.location.href;
	let idUrl: string;
	if (isIsolatedCloud()) {
		idUrl = (getUrlForDomainInContext('id', 'prod') ?? getATLContextUrl('id')).replace('http:', 'https:');
	} else {
		idUrl = getATLContextUrl('id').replace('http:', 'https:');
	}
	return `${idUrl}/login?continue=${encodeURIComponent(href)}&application=people`;
}

// https://developer.atlassian.com/platform/identity/learning/sso/integrate-with-account-switcher/#synchronize-accounts
function getSessionSynchronisationUrl(url: string, userEmail = '') {
	return getLogInUrl(url) + `&prompt=none&login_hint=${userEmail}`;
}
